import { useQueryParam, withDefault } from "use-query-params";

import { CustomJsonParam } from "@north-beam/nb-common";

import { useAllSelectedRowIds } from "../table/contexts";

import { usePerformanceTrackingTableSelectionState } from "./use-selection-state";

const ChartViewParam = CustomJsonParam<"aggregate" | "split">();

export const usePerformanceTrackingChartView = () => {
  const [allSelectedRowIds] = useAllSelectedRowIds();
  const [, setSelectionState] = usePerformanceTrackingTableSelectionState();
  const [chartView, _setChartView] = useQueryParam(
    "chart-view",
    withDefault(ChartViewParam, "aggregate"),
    {
      updateType: "pushIn",
    },
  );

  const setChartView = (view: "aggregate" | "split") => {
    if (view === "aggregate") {
      setSelectionState({
        selectedRowIds: allSelectedRowIds,
        deselectedRowIds: [],
      });
    } else {
      setSelectionState({
        selectedRowIds: allSelectedRowIds.slice(0, 5),
        deselectedRowIds: allSelectedRowIds,
      });
    }
    _setChartView(view);
  };

  return [chartView, setChartView] as const;
};

const ChartMetricParam = CustomJsonParam<string>();
export const usePerformanceTrackingChartMetric = () => {
  return useQueryParam("chart-metric", withDefault(ChartMetricParam, "spend"), {
    updateType: "pushIn",
  });
};
